import { PROGRAM } from "@bussola-viagens/constants"
import { Accordion, AccordionActions, AccordionDetails, AccordionSummary } from "@mui/material"
import { GridExpandMoreIcon } from "@mui/x-data-grid"
import { FormikProps } from "formik"
import WarningIcon from '@mui/icons-material/Warning';
import { Button, PriceSettingsInput, PriceSetting } from "../../../components"

interface CostSettingFormProps {
    label: string
    program: PROGRAM,
    formik: FormikProps<{
        prices: PriceSetting[],
    }>
}

export const CostForm = ({ label, formik }: CostSettingFormProps) => {
    return (
        <form onSubmit={formik.handleSubmit}>
            <Accordion>
                <AccordionSummary
                    expandIcon={<GridExpandMoreIcon />}
                    style={{
                        fontWeight: 'bold'
                    }}
                >
                    {label} 
                    {formik.dirty && <WarningIcon style={{marginLeft: 5}}/>}
                </AccordionSummary>
                <AccordionDetails>
                    <PriceSettingsInput 
                        onChange={(value) => {
                            console.log(value)
                            formik.setFieldValue('prices', value)
                        }}
                        value={formik.values.prices || []}
                    />
                </AccordionDetails>
                <AccordionActions>
                    <Button color="error" onClick={() => formik.resetForm()} disabled={!formik.dirty}>Reverter</Button>
                    <Button type="submit" disabled={!formik.isValid || !formik.dirty}>Salvar</Button>
                </AccordionActions>
            </Accordion>
        </form>
    )
}